import React, { useEffect, useState, useRef } from 'react';
interface LazySectionProps {
  children: ReactNode;
  rootMargin?: string;
  minHeight?: string;
}
export function LazySection({
  children,
  rootMargin = '200px',
  minHeight = '100px'
}: LazySectionProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (!('IntersectionObserver' in window)) {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.disconnect();
      }
    }, {
      rootMargin
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [rootMargin]);
  return <div ref={ref} data-id="element-344">
      {isVisible ? children : <div style={{
      minHeight
    }} data-id="element-345" />}
    </div>;
}